// extracted by mini-css-extract-plugin
export var border = "AppealPage-module--border--830da";
export var bordersection = "AppealPage-module--bordersection--0dadb";
export var contentarea = "AppealPage-module--contentarea--beec1";
export var ctacontainer = "AppealPage-module--ctacontainer--8debc";